import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "bg-white rounded-3 border" }
const _hoisted_3 = { class: "p-4 p-xl-5 d-sm-flex justify-content-between align-items-center position-relative" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "text-nowrap" }
const _hoisted_6 = {
  key: 0,
  class: "text-danger lead"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  class: "bi bi-exclamation-triangle",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" })
], -1)
const _hoisted_8 = {
  key: 1,
  class: "text-success lead"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  class: "bi bi-check2-circle",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" })
], -1)
const _hoisted_10 = {
  key: 0,
  class: "d-none d-sm-block qr-code"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "bg-secondary bg-opacity-10 p-4 p-xl-5" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-5 col-xl-6" }
const _hoisted_15 = { class: "col-md-7 col-xl-6 mt-4 mt-md-0" }
const _hoisted_16 = { class: "h-100" }
const _hoisted_17 = {
  key: 0,
  class: "d-block d-sm-none mt-3"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "px-4 px-xl-5" }
const _hoisted_20 = {
  key: 0,
  class: "mt-4 mt-xl-5"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h2", { class: "h6 text-secondary" }, "Dodatečné informace", -1)
const _hoisted_22 = { class: "mb-0 fst-italic" }
const _hoisted_23 = { class: "mt-4 mt-xl-5" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h2", { class: "h5 text-secondary" }, "Položky", -1)
const _hoisted_25 = {
  key: 0,
  class: "fst-italic text-danger"
}
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-3 col-md-3 col-lg-2 col-xxl-2 pe-0" }
const _hoisted_28 = { class: "p-3 ps-0" }
const _hoisted_29 = { class: "col-5 col-md-6 col-lg-6 col-xxl-6 px-0" }
const _hoisted_30 = { class: "p-3 ps-0" }
const _hoisted_31 = { class: "col-4 col-md-3 col-lg-2 px-0 d-none d-lg-block" }
const _hoisted_32 = { class: "p-3 pe-0 text-end" }
const _hoisted_33 = { class: "col-4 col-md-3 col-lg-2 ps-0" }
const _hoisted_34 = { class: "p-3 pe-0 text-end" }
const _hoisted_35 = {
  key: 1,
  class: "d-flex justify-content-end"
}
const _hoisted_36 = { class: "p-4 p-xl-5 bg-secondary bg-opacity-25 mt-4 mt-xl-5 rounded-bottom" }
const _hoisted_37 = { class: "mt-3" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-0 text-secondary" }, "Faktura nenalezena", -1)
const _hoisted_40 = [
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingOverlay = _resolveComponent("LoadingOverlay")!
  const _component_SubmitButtonSm = _resolveComponent("SubmitButtonSm")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Customer = _resolveComponent("Customer")!
  const _component_PaymentInstructions = _resolveComponent("PaymentInstructions")!
  const _component_Supplier = _resolveComponent("Supplier")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'d-flex justify-content-center align-items-center ' : !_ctx.invoice}, "bg-light py-3 h-100 w-100 overflow-auto position-relative"])
  }, [
    _createVNode(_component_LoadingOverlay, { loading: _ctx.loading }, null, 8, ["loading"]),
    (_ctx.invoice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("h1", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.invoice?.proforma ? 'Proforma faktura' : 'Faktura') + " ", 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.proformaPrefix) + _toDisplayString(_ctx.invoice?.invoiceNumberPretty), 1)
                ]),
                (_ctx.invoice.canceled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(_ctx.invoice.proforma ? 'Proforma faktura' : 'Faktura') + " je stornována ", 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.invoice.paid && !_ctx.invoice.canceled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_ctx.invoice?.proforma ? 'Proforma faktura' : 'Faktura') + " je uhrazena, neplaťte ji. ", 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createVNode(_component_SubmitButtonSm, {
                    name: "Stáhnout PDF",
                    type: "btn-warning",
                    class: "mt-3",
                    loading: _ctx.downloading,
                    onClick: _ctx.handleDownload
                  }, null, 8, ["loading", "onClick"]),
                  (_ctx.loggedIn)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'InvoiceDetail', params: { id: _ctx.invoice?.id} },
                        class: "btn btn-outline-secondary ms-2 mt-3"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" zpět ")
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.invoice?.paymentType === 'Převodem')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: _ctx.qrCodeUrl,
                      width: "200",
                      height: "200",
                      alt: "QR Code"
                    }, null, 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Customer, { customer: _ctx.customer }, null, 8, ["customer"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_PaymentInstructions, {
                      supplier: _ctx.supplier,
                      invoice: _ctx.invoice
                    }, null, 8, ["supplier", "invoice"]),
                    (_ctx.invoice?.paymentType === 'Převodem')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("img", {
                            src: _ctx.qrCodeUrl,
                            width: "200",
                            height: "200",
                            alt: "QR Code"
                          }, null, 8, _hoisted_18)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.invoice?.textBeforeItems)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.invoice.textBeforeItems), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                (_ctx.invoiceItems?.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Faktura nemá žádné položky "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceItems, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass({
                            'border-bottom' : index+1 < _ctx.invoiceItems?.length,
                            'text-decoration-line-through' : _ctx.invoice?.canceled
                        })
                  }, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, _toDisplayString(item.quantity) + " " + _toDisplayString(item.measureUnit || ''), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(item.description), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(item.priceFormatted), 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(item.sumPriceFormatted), 1)
                      ])
                    ])
                  ], 2))
                }), 256)),
                (_ctx.invoiceItems?.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", {
                        class: _normalizeClass([{'text-decoration-line-through' : _ctx.invoice?.canceled }, "h4 mb-0 text-success border-top border-2 border-success text-end w-100 pt-3"]),
                        style: {"max-width":"400px"}
                      }, _toDisplayString(_ctx.invoice?.sumPriceFormatted), 3)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_Supplier, { supplier: _ctx.supplier }, null, 8, ["supplier"]),
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.company?.textOnInvoiceBottom), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
  ], 2))
}